export default __webpack_public_path__ + "static/media/logo.c858a8a4.png";